import { jsx as _jsx } from "react/jsx-runtime";
import { theme, ToastAFY, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
var showToast = function (position, typeAlert, message, onClose) {
    return (_jsx(ToastAFY, { autoclose: 5000, closeOnClick: true, newstOnTop: true, pauseOnHover: true, id: typeAlert, position: position, theme: theme.colored, title: message, type: typeAlert, onClose: function () { return onClose && onClose(); } }));
};
export default showToast;
